import {ImmutableFields, MapAsRecord} from 'immutable';
import React from 'react';

import {ApiOrganization} from 'app/modules/Remote/Organization';
import {LoggedInAuth, useAuth} from 'app/providers/AuthProvider';

// Corresponds to the "Lens Beacon" in Help Scout.
const DASHBOARD_BEACON_ID = 'd80f297f-88ad-4974-b54a-7f03f0575fe9';

const HelpScout: React.FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const auth = useAuth();

  // We split this out so we only run 'init' when the profile object changes.
  // Insulates us from re-initializing on other auth object changes.
  let profile: LoggedInAuth['profile'] | null = null;
  let profileOrganizations: LoggedInAuth['profileOrganizations'] | null = null;
  let profileOrganization: MapAsRecord<ImmutableFields<ApiOrganization>> | null = null;
  if (auth.status === 'logged in') {
    profile = auth.profile;
    profileOrganizations = auth.profileOrganizations;
    const organizationKey = profile?.get('organizationKey');
    if (organizationKey)
      profileOrganization = profileOrganizations?.find((org) => org?.get('id') === organizationKey);
  }

  React.useEffect(() => {
    (window as any)?.Beacon?.('init', DASHBOARD_BEACON_ID);

    if (profile && profileOrganization) {
      (window as any)?.Beacon?.('identify', {
        name: profile.get('name'),
        email: profile.get('email'),
        isLensCustomer: profileOrganization.get('products').includes('Lens'),
        lensTier: profileOrganization.get('tiers').get('Lens'),
        isHydroForecastCustomer: profileOrganization.get('products').includes('HydroForecast'),
        role: profile.get('role'),
      });
    }

    return () => {
      (window as any)?.Beacon?.('logout');
      (window as any)?.Beacon?.('destroy');
    };
  }, [profile, profileOrganization]);

  return null;
};

export default HelpScout;
